/**
 * given an input captured from medium editor determine if it is empty or not
 * @param input
 * @returns {*|boolean}
 */
function isMediumInputEmpty(input) {
  // "<p><br></p>" is a bug from medium editor we consider that as null input
  return input && input !== '<p><br></p>'
}

export default isMediumInputEmpty



// WEBPACK FOOTER //
// ./src/scripts/components/customer/Inputs/isMediumInputEmpty.js